/* eslint-disable */
import "./spinner.css";

export default function LoadingSpinner() {
  return (
    <div className="ring">
      <span className="ring-loading" />
    </div>
  );
}
